

export default {
  name: "backgroundColor",
  nickname: "背景色",
  desc: "backgroundColor",
  value: "transparent",
  defaultValue: "transparent",
  type: "pureValue",
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "BG",
}
